import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const PricingHero = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const textPrimary = isDark ? '#f4f4f4' : '#161616';
  const textSecondary = isDark ? '#c6c6c6' : '#525252';

  return (
    <div style={{ 
      padding: '80px 20px', 
      textAlign: 'center',
      background: isDark 
        ? 'linear-gradient(135deg, #161616 0%, #262626 100%)'
        : '#0f62fe',
      borderBottom: isDark ? '1px solid #393939' : 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '400px'
    }}>
      <div style={{ maxWidth: '800px', width: '100%' }}>
          <h1 style={{ 
            fontSize: '3rem', 
            fontWeight: '700', 
            marginBottom: '24px',
            lineHeight: '1.2',
            textAlign: 'center',
            color: isDark ? textPrimary : '#ffffff'
          }}>
            Monitor Your Cold Chain with Confidence
          </h1>
          <p style={{ 
            fontSize: '1.25rem', 
            color: isDark ? textSecondary : 'rgba(255,255,255,0.85)', 
            marginBottom: '32px',
            lineHeight: '1.6',
            textAlign: 'center'
          }}>
            Start for free with 1 sensor and 1 gateway, then upgrade as you need more. 
            Scale from 1 to 25+ sensors and prevent costly food spoilage with real-time monitoring and automated compliance.
          </p>
      </div>
    </div>
  );
};

export default PricingHero;
